import { createApi } from '@reduxjs/toolkit/query/react';
import { HYDRATE } from 'next-redux-wrapper';

import axiosBaseQuery from '@/api/index';
import { BASE_URL, defaultHeaders } from '@/constants/index';

// Define a service using a base URL and expected endpoints
export const stockApi = createApi({
  reducerPath: 'stockApi',
  baseQuery: axiosBaseQuery(),
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === HYDRATE) {
      return action.payload[reducerPath];
    }
  },
  tagTypes: ['STOCK'],
  endpoints: (builder) => ({
    getStock: builder.query({
      query: (params) => ({
        baseURL: BASE_URL,
        url: '/number-discovery/stock',
        params: {
          ...params,
          providerId: 2,
        },
        headers: defaultHeaders,
      }),
    }),
    getNumberDetails: builder.query({
      query: (id) => ({
        baseURL: BASE_URL,
        url: `/number-discovery/stock/msisdn/${id}`,
        headers: defaultHeaders,
      }),
    }),
  }),
});

export const hooks = {
  useGetStock: stockApi.useGetStockQuery,
  useGetNumberDetails: stockApi.useGetNumberDetailsQuery,
};

export default stockApi;
